import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { PsvNode } from '@indutrust/factory-model';
import { EnvironmentService } from '@indutrust/shared-env';
import type { Observable } from 'rxjs';

/**
 * API client for virtual-tour node action endpoints that do not fit the
 * `BaseApiClient<T>` REST shape — currently the multipart panorama upload
 * `PATCH /vr_psv_nodes/{nodeId}/update_panorama`.
 *
 * Mirrors {@link import('../factory/factory-actions-api-client.service').FactoryActionsApiClient}'s
 * `update_logo` pattern: JSON CRUD lives on {@link import('./vr-node-api-client.service').VrNodeApiClient},
 * binary panorama uploads go here.
 */
@Service()
export class VrNodeActionsApiClient {
  private readonly envService = inject(EnvironmentService);
  private readonly http = inject(HttpClient);

  /**
   * Uploads (or replaces) the equirectangular panorama image for a node.
   * @param nodeId - Id of the virtual-tour node to update.
   * @param panorama - The panorama image file to upload.
   * @returns An observable emitting the updated {@link PsvNode}.
   */
  updatePanorama(nodeId: number, panorama: File): Observable<PsvNode> {
    const form = new FormData();
    form.append('panorama', panorama);
    return this.http.patch<PsvNode>(
      `${this.baseUrl}/vr_psv_nodes/${nodeId}/update_panorama`,
      form
    );
  }

  private get baseUrl(): string {
    return this.envService.getApiUrl();
  }
}
